import { Component, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { ActivatedRoute, NavigationStart, Router } from '@angular/router';
import {
  AlertController,
  LoadingController,
  NavController,
  Platform
} from '@ionic/angular';
import { Subject, Subscription, switchMap, takeUntil, interval, timer, firstValueFrom , take, BehaviorSubject} from 'rxjs';

import { AuthService } from '../../services/auth-service/auth-service';
import { RilevazionePresenzeService } from '../../services/rilevazione-presenze-service';

// import { AbstractPage } from '../AbstractPage';
import { TranslateService } from '@ngx-translate/core';

import { EventEmitter } from '@angular/core';
import { Coordinates, Geolocation } from '@awesome-cordova-plugins/geolocation/ngx';
import { NgxQrcodeElementTypes, NgxQrcodeErrorCorrectionLevels } from '@techiediaries/ngx-qrcode';
import { format } from 'date-fns';
import itLocale from 'date-fns/locale/it';
import { GruppoStudenti } from 'src/app/models/registro/gruppo-studenti';
import { StudenteClasse } from 'src/app/models/registro/studente-classe';
import { ConfermaPresenza } from 'src/app/models/rilevazione-presenze/conferma-presenza';
import { Presenza } from 'src/app/models/rilevazione-presenze/presenza';
import { Prenotato } from 'src/app/models/student-booking.models';
import { ConfermaPresenzaService } from 'src/app/services/conferma-presenza-service';
import { EnvService } from 'src/app/services/env-service/env-service';
import { EventsService } from 'src/app/services/eventsService';
import { GruppiStudentiService } from 'src/app/services/gruppi-studenti-service';
import { UserService } from 'src/app/services/user-service';
import { UtilityService } from 'src/app/services/utility.service';
import { InvioNotificaPage } from '../../invio-notifica/invio-notifica.page';
import { ChiaveConfig } from '../../models/configurazioni/ChiaveConfig';
import { Rilevazione, StatoPrenotazione, StatoRilevazione } from '../../models/rilevazione-presenze/rilevazione';
import { ConfigService } from '../../services/config-service/config-service';
import { DataService } from '../../services/data-service';
import { PlatformName } from '../../services/env-service/env-platform';
import { GeolocUtilityService } from '../../services/geolocutility.service';
import { VerificaPresenzaPage } from '../../verifica-presenza/verifica-presenza.page';
import { ModificaRilevazioneComponent } from './modifica-rilevazione/modifica-rilevazione.component';
import { RilNotesComponent } from './ril-notes/ril-notes.component';
/* La pagina di raccolta presenze
 *
 * Riceve in input la rilevazione come parametro di navigazione
 */

@Component({
    selector: 'app-ril-viewer',
    templateUrl: './ril-viewer.component.html',
    styleUrls: ['./ril-viewer.component.scss'],
    standalone: false
})


export class RilViewerComponent implements OnInit, OnDestroy {

  percentualePresenti: string;
  rilevazione: Rilevazione;
  presenza: Presenza;
  numeroInElenco: number;
  numeroPresentiNonSegnalati: number;
  numeroPresentiGeolocalizzati: number;
  numeroAssenti: number;
  numeroConfermati: number;
  // se true la ui mostra il pulsante per cancellare la rilevazione presenze
  mostraCancella: boolean;
  // se true indica che la configurazione prevede  il pulsante per concludere la rilevazione
  concludiAbilitato: boolean;
  // se 0 non è possibile effettuare la verifica della presenza
  verificaPresenzaAbilitato: boolean;
  presenzaVerificata: boolean;
  now: number;
  elapsedTime: number;
  refreshTimeSubscription: Subscription;
  riladdress: string;
  navigationSubscription: Subscription | null = null;
  ritardoConfigurato: number;
  geolocalizzazioneAttiva: boolean;
  countSubscription: Subscription;
  coords: Coordinates;
  localizzazioneInCorso: boolean;
  geolocactive = false;
  presenzaconfermata = false;
  verificaAvviata = false;
  sbIntegrationIsActive = true;
  showSBButton = false;
  prenotati: Prenotato[];
  numeroPrenotati: number;
  prenotatiNonRecuperati: string = null;
  activerilmessage: any;
  impedisciVerifica = false;
  warningTime = false;
  studentiClasse: StudenteClasse[];
  gruppiStudenti: GruppoStudenti[];
  paginaPrecedente: string;
  differentRemoteDataMessage: string;
  elementType: NgxQrcodeElementTypes;
  correctionLevel: any;
  qrcodeval$ = new BehaviorSubject<string>(null);
  useQrcodeIul: boolean;
  userRole: string;

  oreAccademiche = this.configService.getConfigurazione(ChiaveConfig.VAL_ORE_ACCADEMICHE);
  cdsList = this.configService.getConfigurazione(ChiaveConfig.CDS_LIST_REDUCED_HOURS).split(',');
  rilAccademica = false;
  oreAccMsg: string;
  subcriptionsElencoStudentiCreated: boolean;

  abusoAsAssenzaFilter = this.configService.getConfigurazione(ChiaveConfig.ABUSO_AS_ASSENZA_FILTER);

  protected qrModalOpen = false;
  protected dynamicCodeEnabled = false;
  
  private unsubscribeAll$ = new Subject<void>();

  constructor(
    public navCtrl: NavController,
    private platform: Platform,
    public router: Router,
    public route: ActivatedRoute,
    private translateService: TranslateService,
    public configService: ConfigService,
    private rilevazionePresenzeService: RilevazionePresenzeService,
    private dataService: DataService,
    private alertCtrl: AlertController,
    private geolocUtilityService: GeolocUtilityService,
    private loadingCtrl: LoadingController,
    private confermaPresenzaService: ConfermaPresenzaService,
    private geolocation: Geolocation,
    private envService: EnvService,
    private events: EventsService,
    public utilityService: UtilityService,
    public userService: UserService,
    public authService: AuthService,
    private gruppiStudentiService: GruppiStudentiService

    ) {
    // super(navCtrl, router);
    // dopo decine di frustranti tentativi di recuperare un oggetto dalla route
    // ho implementato la soluzione che fa uso di un provider di scambio dati
    // il NavController di Ioni 3 evidentemente faceva qualcosa di simile
    // in maniera trasparente
    this.rilevazione = this.dataService.rilevazione;
    this.presenza = this.dataService.presenza;
    console.log('this.rilevazione' , this.rilevazione);
    console.log('this.presenza' , this.presenza);
    this.dataService.rilevazione = null;
    this.dataService.presenza = null;
    this.dataService.prenotati = null;

    this.events.paginaPrecedente.subscribe(url => {
      this.paginaPrecedente = url;
    });
  }

  @Input() modeDoc = true;
  @Input() inmessage: string;
  @Output() rilClosed = new EventEmitter();
  @Output() countSubscriptionActivated = new EventEmitter();
  @Output() refreshTimeSubscriptionActivated = new EventEmitter();
  @Input() registryIntegration = false;

  async ngOnInit() {
    console.log('ngOnInit RilViewer');
    if (this.modeDoc) {
      this.useQrcodeIul =
        this.configService.getConfigurazione(ChiaveConfig.USE_QRCODE_IUL) ===
        'true';

      this.concludiAbilitato =
        this.configService.getConfigurazione(ChiaveConfig.PULSANTE_CONCLUDI) ===
        'true';

        if (!this.rilevazione.conclusa() && !this.inmessage) {
            this.inmessage = this.translateService.instant('rilevazione-home.message.rilattiva');
        }
        // genera il qrcode
        this.elementType = NgxQrcodeElementTypes.IMG;
        this.correctionLevel = NgxQrcodeErrorCorrectionLevels.HIGH;
        if (this.configService.getConfigurazione(ChiaveConfig.ABILITA_DYNAMIC_QRCODE) === 'true') {
          this.dynamicCodeEnabled = true;
          this.codePolling();
        } else {
          this.dynamicCodeEnabled = false;
          this.qrcodeval$.next(this.rilevazione.iul);
        }
    }

    this.verificaPresenzaAbilitato =
        this.configService.getConfigurazione(
          ChiaveConfig.SECONDI_VERIFICA_PRESENZE
        ) > 0;
    this.ritardoConfigurato =
      this.configService.getConfigurazione(
        ChiaveConfig.MINUTI_RITARDO
      );
    this.geolocalizzazioneAttiva =
      this.configService.getConfigurazione(
        ChiaveConfig.GEOLOCALIZZA_RILEVAZIONE
      ) === 'true';


      if (this.geolocalizzazioneAttiva) {

        console.log('recupero address');

        if (this.rilevazione) {
          console.log('address ', this.rilevazione.address);
          this.riladdress = this.rilevazione.address;
          if (!this.riladdress) {
            console.log('aggiornamento address rilevazione');
            if (this.rilevazione.latitudine) {
              if (this.platform.is(PlatformName)) {
                await this.geolocUtilityService.getAddressMobile(this.rilevazione.latitudine, this.rilevazione.longitudine, (address) => {
                  this.riladdress = address;
                  console.log('address (native) ', this.riladdress);
                  this.rilevazione.address = address;
                  this.rilevazionePresenzeService.updateRilAddress(this.rilevazione).subscribe();
                });
            } else {
                await this.geolocUtilityService.getAddressBrowser(this.rilevazione.latitudine, this.rilevazione.longitudine, (address) => {
                  this.riladdress = address;
                  console.log('address (web)', this.riladdress);
                  this.rilevazione.address = address;
                  this.rilevazionePresenzeService.updateRilAddress(this.rilevazione).subscribe();
                });
              }
            }
          }
        }
      }

      console.log('proseguo');


      if (this.modeDoc) {
        await this.checkSbIntegration();
        console.log('after checkSbIntegration', this.sbIntegrationIsActive);
        if (this.sbIntegrationIsActive) {
          // potrebbero esserci i dati dell'impegno e
          // quindi dell evento per accedere a sb
          if (this.rilevazione.prenotazione === StatoPrenotazione.PREVISTA
              || this.rilevazione.prenotazione === StatoPrenotazione.FACOLTATIVA) {

            this.rilevazionePresenzeService
            .getPrenotati(this.rilevazione)
            .subscribe(
              prenotati => {
                this.prenotati = prenotati;
                console.log('this.prenotati', this.prenotati);
                if (this.prenotati) {
                  this.numeroPrenotati = this.prenotati.length;
                  this.showSBButton = this.numeroPrenotati > 0 ? true : false;
                  console.log('this.showSBButton', this.showSBButton);
                  console.log('n prenotati in sb', this.numeroPrenotati);
                  console.log('prenotati in sb', this.prenotati);
                }
              }
            );
          } else if (this.rilevazione.prenotazione === StatoPrenotazione.NONRECUPERATA) {
              // segnala il problema del non essere riusciti a recuperare i prenotati
              // this.prenotatiNonRecuperati = 'Non è stato possibile recuperare i prenotati alla lezione';
              this.prenotatiNonRecuperati =
                this.translateService.instant('ril-viewer.message.prenotazioninonrecuperate');
                console.log(this.prenotatiNonRecuperati);
          }
        }

        if (this.authService.registryIntegration) {
          if (this.rilevazione.remoteStartDateTime || this.rilevazione.remoteDurata) {
            const dateOpts = {locale: itLocale};
            const remotesdt = format(new Date(this.rilevazione.remoteStartDateTime ?
              this.rilevazione.remoteStartDateTime :
              this.rilevazione.istanteCreazione), 'dd/MM/yyyy HH:mm', dateOpts);

            const remotedur = this.rilevazione.remoteDurata ? this.rilevazione.remoteDurata / 60 : 0;

            this.differentRemoteDataMessage =
                      this.translateService.instant('ril-viewer.message.differentremotedatamessage',
                       { remoteinfo: remotesdt + ', ' + remotedur + ' ore' });
          }
        }

        // qui carico gruppi e classe
        if (this.registryIntegration) {
          const loader = await this.loadingCtrl.create({
            message: this.translateService.instant('label.richiestaincorso')
          });
          loader.present();
          // recupera gli studenti
          this.gruppiStudentiService.cercaClasseStudentiPerAdLogId(this.authService.getAdLogId()).subscribe((data) => {
            console.log('studenti', data);
            this.studentiClasse = data;
            this.utilityService.orderBy( { field: 'matricola', ascdesc: 'asc'}, this.studentiClasse);
            // recupera i gruppi
            this.gruppiStudentiService.cercaGruppiStudentiPerAdLogId(this.authService.getAdLogId()).subscribe((grps) => {
              console.log('gruppi', grps);
              this.gruppiStudenti = grps;
              this.utilityService.orderBy( { field: 'descrizione', ascdesc: 'asc'}, this.gruppiStudenti);
              loader.dismiss();
            }, (error) => {
              console.log('error', error);
              loader.dismiss();
            }            );
          }, (error) => {
            console.log('error', error);
            loader.dismiss();
          });
        }

      // avvia i timer se necessario
        if (this.rilevazione.conclusa()) {
          this.countDocente();
        } else {
          console.log('avvio i refresh ');
          // timer per conteggio tempo trascorso
          this.refreshTimeSubscription = timer(0, 1000).subscribe(() => this.setNow());
          this.refreshTimeSubscriptionActivated.emit(this.refreshTimeSubscription);
          // count con refresh
          this.countSubscription = timer(0, 5000).subscribe(() => this.countDocente());
          this.countSubscriptionActivated.emit(this.countSubscription);
        }
      } else {
        if (!this.rilevazione.conclusa()) {
          console.log('avvio il refresh ');
          // timer per conteggio tempo trascorso
          this.refreshTimeSubscription = timer(0, 1000).subscribe(() => this.setNow());
          this.refreshTimeSubscriptionActivated.emit(this.refreshTimeSubscription);

          if (this.geolocalizzazioneAttiva) {
            this.getCoords();
          }
      // FIXME sarà necessario introdurre un timer che esegua il refresh della rilevazione per lo studente
        }
      }

      if (this.modeDoc) {
        this.presenzaVerificata = true; // per non disegnare il pulsante finchè non risponde aggiornamentoPresenze()
        this.rilevazionePresenzeService
          .aggiornamentoPresenze(this.rilevazione)
          .subscribe(
            dati => {
              this.presenzaVerificata = dati.verifichePresenza.length > 0;
              this.numeroConfermati = dati.verifichePresenza[0];
              console.log('ngOninit this.numeroConfermati ', this.numeroConfermati );
            },
            e => {
              console.log(e);
            }
          );
      }

      this.events.geolocIsActive.subscribe(data => {
        console.log('geolocIsActive subscription');
        this.geolocactive = data.geolocactive;
        this.coords = data.coords;
        if (!this.coords) {
          this.localizzazioneInCorso = false;
        }
      });

      this.userRole = this.userService.getUtenteCorrente().ruolo;

      // this.oreAccademiche = (this.rilevazione.durata / 60) * 45;

      this.showMsgAccademico();

  }

  ngOnDestroy() {
    console.log('ngOnDestroy');
    this.stopSubscriptions();
    this.geolocUtilityService.turnGeolocCheckOff();
    // this.dataService.rilevazione = null;
    // this.dataService.presenza = null;
  }

  async countDocente(refresher?) {
    console.log("countDocente")
    this.rilevazionePresenzeService.getConteggiRilevazione(this.rilevazione).subscribe(
      cr => {
        this.numeroInElenco = cr.countTutti;
        this.mostraCancella = cr.countTutti <= 0;
        // console.log('this.mostraCancella', this.mostraCancella);
        if (this.registryIntegration) { // al momento nell'integrazione con il registro non consentiamok la cancellazione della ril
          // console.log('reimposto mostraCancellaa');
          this.mostraCancella = false;
        }

        if(this.abusoAsAssenzaFilter === "false") {
          this.numeroAssenti = cr.countAssenti;
        }
        else {
          this.numeroAssenti = cr.countAssenti + cr.countAbusi;
        }
        
        this.numeroPresentiNonSegnalati = cr.countPresenti;
        this.numeroPresentiGeolocalizzati = cr.countGeolocalizzati;

        this.refreshRilevazione(this.elapsedTime);
        if (refresher) {
          refresher.target.complete();
        }

      },
      error => {
        this.numeroInElenco = null;
        if (refresher) {
          refresher.target.complete();
        }
      }
    );

    // aggiungo questa verifica in modo da far scomparire il tasto
    // di verifica presenze una volta effettuata
    if (!this.presenzaVerificata) {
      this.verificaAvviata = false;
      await this.rilevazionePresenzeService
      .aggiornamentoPresenze(this.rilevazione)
      .subscribe(
        dati => {
          this.presenzaVerificata = dati.verifichePresenza.length > 0;
          this.numeroConfermati = dati.verifichePresenza[0];
        },
        e => {
          // in caso di errori meglio far comparire il pulsante tanto
          // dopo c'è un ulteriore  controllo
          this.presenzaVerificata = false;
          console.log(e);
        }
      );
    }
  }
  refresh(refresher) {
    if (this.modeDoc) {
      this.countDocente(refresher);
    }
  }

  showSBList() {
    this.apriElencoStudenti(true);
  }
  apriDettaglio() {
    this.apriElencoStudenti(false);
  }


  apriElencoStudenti(showprenotati: boolean) {

    if (!this.subcriptionsElencoStudentiCreated) {

      this.subcriptionsElencoStudentiCreated = true;

      // aggiunta la subscribe all'evento di modifica delle presenze per poter
      // indicare correttamente il numero di presenti
      this.events.presenzeUpdated.subscribe(() => {
        // console.log( 'updatedData ',  updatedData );
        this.countDocente();
      });
      this.events.confermeUpdated.subscribe(() => {
        this.rilevazionePresenzeService
        .aggiornamentoPresenze(this.rilevazione)
        .subscribe(
          dati => {
            this.numeroConfermati = dati.verifichePresenza[0];
          });
      });
      this.events.backFromElencoPresenti.pipe(take(1)).subscribe(() => {
        //console.log('back-from-elenco-presenti');

        this.rilevazione = this.dataService.rilevazione;
        this.countDocente();

        this.studentiClasse = this.dataService.studentiClasse;
        this.gruppiStudenti = this.dataService.gruppiStudenti;

        if (!this.rilevazione.conclusa()) {
          console.log('registry integration attiva: avvio i refresh ');
          // timer per conteggio tempo trascorso
          this.refreshTimeSubscription = timer(0, 1000).subscribe(() => this.setNow());
          this.refreshTimeSubscriptionActivated.emit(this.refreshTimeSubscription);
          // count docente

          this.countSubscription = timer(0, 5000).subscribe(() => this.countDocente());
          this.countSubscriptionActivated.emit(this.countSubscription);
        }


      });
    }

    this.dataService.prenotati = this.prenotati;
    this.dataService.rilevazione = this.rilevazione;
    this.dataService.showprenotati = showprenotati;
    this.dataService.studentiClasse = this.studentiClasse;
    this.dataService.gruppiStudenti =  this.gruppiStudenti;
    console.log('this.dataService.gruppiStudenti', this.dataService.gruppiStudenti);
    this.navCtrl.navigateForward('elenco-presenti');

  }
  apriMappa() {
    this.dataService.rilevazione = this.rilevazione;
    this.navCtrl.navigateForward('mappa-presenze');
  }

  segnalaUscitaAnticipata(presenza: Presenza) {
    console.log('segnalaUscitaAnticipata');
    this.rilevazionePresenzeService.segnalaUscita(presenza)
    .subscribe(() => {
        this.utilityService.showHint('ril-viewer.message.uscita-ok');
        setTimeout(() => {
          this.navCtrl.navigateForward('marcatura-home');
          }, 1000);
      },
      error => {
        this.utilityService.showError(error);
        setTimeout(() => {
          this.navCtrl.navigateForward('marcatura-home');
          }, 1000);
    }
  );
  }

  verificaPresenze() {
    console.log('this.verificaAvviata', this.verificaAvviata);
    if ( !this.verificaAvviata ) {
      this.verificaAvviata = true;
      this.rilevazionePresenzeService
    .aggiornamentoPresenze(this.rilevazione)
    .subscribe(
      async dati => {
        this.presenzaVerificata = dati.verifichePresenza.length > 0;
        if ( this.presenzaVerificata ) {
          this.utilityService.showHint( 'ril-viewer.verifica.message' ) ;
          console.log( 'this.presenzaVerificata',  this.presenzaVerificata);
        } else {
          const modalResp = await this.utilityService.showModal(VerificaPresenzaPage,
            { rilevazione: this.rilevazione },
            'verifica-presenze-modal-css' ,
            );
          console.log('modalResp', modalResp);
          this.verificaAvviata = false; // potrebbe aver usato annulla
          if (modalResp.data) {
            this.reportVerificaPresenze();
          }
        }
      },
      e => {
        console.log(e);
      }
    );
   }
  }


  reportVerificaPresenze() {
    console.log('reportVerificaPresenze');
    this.rilevazionePresenzeService
      .aggiornamentoPresenze(this.rilevazione)
      .subscribe(
        dati => {
          // console.dir(dati);
          let percentualeConferme = 0;
          if (dati.verifichePresenza[0] > 0 && dati.count > 0) {
            percentualeConferme =
              (100 * dati.verifichePresenza[0]) / dati.count;
          }
          this.presenzaVerificata = dati.verifichePresenza.length > 0;
          this.percentualePresenti = `${percentualeConferme.toFixed(2)}%`;
          this.numeroConfermati = dati.verifichePresenza[0];
          this.utilityService.showHint('raccolta-presenze.msg.report-verifica', this.percentualePresenti);
        },
        e => {
          console.log(e);
        }
      );
  }

  async notificaForm() {
    const modalResp = await this.utilityService.showModal(InvioNotificaPage, {
      rilevazione: this.rilevazione
    });
    console.log('modalResp', modalResp);
    if (modalResp.data) {
      // console.log(JSON.stringify(data));
      this.rilevazionePresenzeService
        .inviaNotifica(
          this.rilevazione,
          modalResp.data.testo,
          modalResp.data.oggetto
        )
        .subscribe(
          () => {
            this.utilityService.showHint('raccolta-presenze.msg.notifica-inviata');
          },
          e => {
            console.log(e);
            this.utilityService.showHint('raccolta-presenze.msg.notifica-non-inviata');
          }
        );
    }
  }

  cancella() {
    this.rilevazionePresenzeService
    .rimuoviRilevazione(this.rilevazione)
    .subscribe({
      next: () => {
        this.utilityService.showHint('raccolta-presenze.msg.cancellata');
        if (this.paginaPrecedente === '/storico-rilevazioni') {
          this.navCtrl.navigateBack('storico-rilevazioni');
          this.events.reloadRils.next(this.rilevazione.iul);
        } else if (this.paginaPrecedente === '/storico-rilevazioni-per-ar') {
          this.navCtrl.navigateBack('storico-rilevazioni-per-ar');
          this.events.reloadArRils.next(this.rilevazione.iul);
          this.events.reloadRils.next(this.rilevazione.iul);
        } else if (this.paginaPrecedente === '/usa-delega;mode=storico') {
          this.navCtrl.navigateBack('/usa-delega;mode=storico');
          this.events.reloadDeleghe.next();
        }
      },
      error: e => {
        this.utilityService.showError(e);
        // è corretto procedere con l'aggiornamento degli elenchi delle ril se c'è stato un errore?
        if (this.paginaPrecedente === '/storico-rilevazioni') {
          this.navCtrl.navigateBack('storico-rilevazioni');
          this.events.reloadRils.next(this.rilevazione.iul);
        } else if (this.paginaPrecedente === '/storico-rilevazioni-per-ar') {
          this.navCtrl.navigateBack('storico-rilevazioni-per-ar');
          this.events.reloadArRils.next(this.rilevazione.iul);
          // va pubblicato anche il reload rils su storico-rilevazioni
          this.events.reloadRils.next(this.rilevazione.iul);
        }
      }
    });
  }

  concludi() {
    this.rilevazionePresenzeService
      .concludi(this.rilevazione)
      .subscribe(ril => {
        this.qrcodeval$.next(this.rilevazione.iul);
        if (this.paginaPrecedente === '/storico-rilevazioni') {
          this.events.reloadArRils.next(this.rilevazione.iul);
        }
        this.updateMessageAndRil(ril);
      });
  }


  activeSince() {
    // this.elapsedTime = 0;
    if (this.rilevazione.istanteCreazione) {
      this.elapsedTime = this.now - new Date(this.rilevazione.istanteCreazione).valueOf() ;
      // console.log('this.now', this.now);
      // console.log('this.rilevazione.istanteCreazione', this.rilevazione.istanteCreazione);
      // console.log('this.rilevazione.istanteCreazione.valueOf()', this.rilevazione.istanteCreazione.valueOf());
      // console.log('elapsedTime', this.elapsedTime);
      this.elapsedTime = this.elapsedTime / 1000 ;
    }

    this.controlloAbilitazioneVerifica();

    /* this.controlloChiusuraOraAccademica(); */

    return this.utilityService.formatDate(this.elapsedTime);
  }

  async refreshRilevazione(elapsedTime: number) {
      // aggiorna comunque il numero di presenti che altrimenti non risulterebbe aggiornato
      // nel caso di avvio della verifica presenze
      this.rilevazione.numeroPresenze = this.numeroInElenco;
      // console.log('refreshStatoRilevazione elapsedTime',  elapsedTime);
      // console.log('durata', this.rilevazione.durata);
      // console.log('this.now', this.now);
      // console.log('this.rilevazione.istanteCreazione.valueOf()', this.rilevazione.istanteCreazione.valueOf());
      // console.log('refreshRilevazione elapsedTime', (elapsedTime / 60).toFixed(0));
      // è trascorso più del tempo di ritardo configurato e quando è stata caricata la rilevazione era in corso
      const inRitardo = (elapsedTime - this.ritardoConfigurato * 60 ) > 0 ;
      // console.log('refreshRilevazione inRitardo', inRitardo);
      if ( inRitardo && this.rilevazione.stato === StatoRilevazione.IN_CORSO ) {
        await this.ricaricaRilevazione();
      }

      // la rilevazione si è conclusa
      let remainingTime = 0;
      if (this.oreAccademiche !== 60 && this.rilevazione.ar.cds.length !== 0) {
        if (this.cdsList.includes(this.rilevazione.ar.cds[0].id) && this.rilevazione.durata >= 60) {
          remainingTime = (this.rilevazione.durata  * this.oreAccademiche ) - elapsedTime;
        } else {
          remainingTime = (this.rilevazione.durata  * 60 ) - elapsedTime;
        }
      } else {
        remainingTime = (this.rilevazione.durata  * 60 ) - elapsedTime;
      }

      if ( remainingTime < 0 ) {
        await this.ricaricaRilevazione();
      }
    }


  setNow() {
    this.now = (new Date).valueOf();
    // console.log('set now', this.now);
  }

  async showalert( message: string ) {
    (await this.alertCtrl.create({
     header: this.translateService.instant('ril-viewer.locate.title'),
     message: message,
     buttons: ['OK']
   }))
   .present();
 }

 async showAddress() {
   if (this.riladdress) {
    await this.showalert( this.riladdress );
   }
 }

 async ricaricaRilevazione() {
  // console.log('ricaricaRilevazione');
  await this.rilevazionePresenzeService
  .cercaRilevazione(this.rilevazione.iul)
  .subscribe(
    async ril => {
      if (ril) {
          this.rilevazione = ril;
          await this.updateMessageAndRil(ril);
          // console.log('ricaricaRilevazione update rilevazione');
        }
    },
    error => {
      console.log('impossibile aggiornare la rilevazione');
    }
  );
 }

async updateMessageAndRil(r: Rilevazione) {
//  console.log('updateMessageAndRil', this.inmessage);
  if (r) {
    if (r.conclusa()) {
      if ( this.inmessage ) {
        this.inmessage = this.translateService.instant('rilevazione-home.message.rilconclusa');
      }
      // console.log('updateMessageAndRil update rilevazione');
      this.rilevazione = r;
      this.stopSubscriptions();
      this.rilClosed.emit(r);
    }
  }
}

openMap(presenza: Presenza) {
  this.dataService.rilevazione = null;
  this.dataService.presenza = presenza;
  this.navCtrl.navigateForward('mappa-presenze');
}

async confermaPresenza(presenza: Presenza) {
  const presenze = await this.rilevazionePresenzeService
  .getPresenzaStudente(this.userService.getStudenteCorrente(), this.rilevazione)
  .toPromise();

  this.presenza = presenze[0];
  this.activerilmessage = this.translateService.instant('marcatura-home.message.marcaturainviata');
  console.log('this.dataService.presenza1', this.dataService.presenza);

  if (this.presenza.stato.toString() !== 'ABUSO') {
      const loader = await this.loadingCtrl.create({
      message: this.translateService.instant('label.richiestaincorso')
    });
    loader.present();

    console.log('Conferma presenza');
    this.confermaPresenzaService
      .confermaPresenza(presenza, this.coords)
      .subscribe(
        (conferma: ConfermaPresenza) => {
          loader.dismiss();
          console.log(conferma);
          this.presenzaconfermata = true;
          this.utilityService.showHint('storico-marcature.label.conferma-ok');
        },
        error => {
          loader.dismiss();
          this.utilityService.showError(error);
      }
    );
  }
}

getCoords() {
  const options = {
    enableHighAccuracy: true,
    timeout: this.envService.GEOLOC_TIMEOUT,
  };
  this.coords = null;
  this.localizzazioneInCorso = true;
  this.geolocation
    .getCurrentPosition(options)
    .then(resp => {
      this.coords = resp.coords;
      this.localizzazioneInCorso = false;
      console.log(
        'geoloc: ' +
          resp.coords.latitude +
          ' ' +
          resp.coords.longitude +
          ' - acc:' +
          resp.coords.accuracy
      );
    })
    .catch(error => {
      this.localizzazioneInCorso = false;
      console.log('Error getting location', error);
      console.log('Error code', error.code);
      console.log('Error message', error.message);
    });

    this.geolocUtilityService.turnGeolocCheckOn();
  }

  showHint(mess, mess2: string = null, event = null) {
    this.utilityService.showHintNoProp(mess, mess2, event);
  }

  async print(iul: string) {
    const loader = await this.loadingCtrl.create({
      message: this.translateService.instant('label.richiestaincorso')
    });
    loader.present();

    // const type = 'image/png;charset=UTF-8';
    const type = 'application/pdf;charset=UTF-8';
    const ext = 'pdf';

    this.rilevazionePresenzeService.stampaRilevazione(iul)
    .subscribe(
      async data => {
        await this.utilityService.downloadFile(data, `IUL_${iul}`, type , ext);
        loader.dismiss();
        console.log('download complete ', new Date());
      },
    error => {
      console.log('Error downloading the file.' + error);
      loader.dismiss();
      this.utilityService.showError(error);
    });
  }
  async checkSbIntegration() {
    console.log('check SB integration');
      this.rilevazionePresenzeService.verificaIntegrazioneSbAttiva().subscribe(n => {
        if (n === 1) {
          this.sbIntegrationIsActive = true;

        }
        console.log(' SB integration active? ', this.sbIntegrationIsActive);
      });
  }

  controlloAbilitazioneVerifica() {
    let remainingTime
    if (this.oreAccademiche !== 60 && this.rilevazione.ar.cds.length !== 0) {
      if (this.cdsList.includes(this.rilevazione.ar.cds[0].id) && this.rilevazione.durata >= 60) {
        remainingTime = (this.rilevazione.durata  * this.oreAccademiche ) - this.elapsedTime;
      } else {
        remainingTime = (this.rilevazione.durata  * 60 ) - this.elapsedTime;
      }
    } else {
      remainingTime = (this.rilevazione.durata  * 60 ) - this.elapsedTime;
    }
    let secondiVerificaPresenze: number;
     secondiVerificaPresenze =
      this.configService.getConfigurazione(
        ChiaveConfig.SECONDI_VERIFICA_PRESENZE
      );
    const warningTimeSecs = 900;
    if (remainingTime <= warningTimeSecs && remainingTime > secondiVerificaPresenze) {
      this.warningTime = true;
      // console.log("warningTime T", this.warningTime);
    } else {
      this.warningTime = false;
      // console.log("warningTime F", this.warningTime);
    }
    if (remainingTime <= secondiVerificaPresenze && !this.impedisciVerifica) {
      this.impedisciVerifica = true;
      this.events.verificaDisattivata.next();
    }
  }

  async openNote() {
    const modalResp = await this.utilityService.showModal(RilNotesComponent,
      {note: this.rilevazione.note},
      'notes-viewer-modal-css',
      false
      );
    if (modalResp.data) {
      this.salvaNote(this.rilevazione, modalResp.data);
    }
  }

  salvaNote(ril: Rilevazione, data: any) {
    ril.note = data.note;
    this.rilevazionePresenzeService.updateRilNotes(ril).subscribe();
  }

  async modificaRilevazione() {
    const formatString = 'yyyy-MM-dd' + '\'T\'' + 'HH:mm';

    const modalResp = await this.utilityService.showModal(ModificaRilevazioneComponent,
      {rilevazione: this.rilevazione},
      'modifica-rilevazione-modal-css' ,
      false
      );
    if (modalResp.data) {
      // const istanteCreazione = this.rilevazione.istanteCreazione;
      // const istanteCreazione = modalResp.data.istanteCreazione;
      // const data = new Date(this.rilevazione.istanteCreazione);
      // data.setHours(data.getHours() + (data.getTimezoneOffset() / 60));
      // istanteCreazione = format(data, formatString);
      const loader = await this.loadingCtrl.create({
        message: this.translateService.instant('label.richiestaincorso')
      });
      loader.present();

      this.rilevazionePresenzeService.modificaRilevazione(modalResp.data.ril, modalResp.data.moveMarcature).subscribe(rilevazione => {
        this.rilevazione = rilevazione;
        this.showMsgAccademico();
        this.events.reloadArRils.next(this.rilevazione.iul);
        loader.dismiss();
      },
      e => {
        loader.dismiss();
        console.log(e);
        const title = this.translateService.instant('label.warning');
        const message = this.utilityService.extractErrorMsg(e);
        this.utilityService.presentSimpleAlert(message, title, () => {
          this.events.reloadArRils.next(this.rilevazione.iul);
          }, this.translateService.instant('label.dismiss'));
      });
    }
  }

  showMsgAccademico() {
    if (this.oreAccademiche !== 60 && this.rilevazione.ar.cds.length !== 0) {
      if (this.cdsList.includes(this.rilevazione.ar.cds[0].id)) {
        this.rilAccademica = true;
        this.oreAccMsg = this.translateService.instant('ril-viewer.sottotitolo.oreAcc',
          {
            n: (((this.rilevazione.durataReale - this.rilevazione.durataReale % 60) / 60)
                                    * this.oreAccademiche) + this.rilevazione.durataReale % 60
          }
        );
      }
    }
  }

  protected getCodeLabel(rilevazione: Rilevazione) {
    if (!this.dynamicCodeEnabled || rilevazione.conclusa()) { return 'raccolta-presenze.label.iul'; }
    return 'raccolta-presenze.label.dynamicCode';
  }

  private stopSubscriptions() {
    console.log('stopSubscriptions');
    this.unsubscribeAll$.next();

    if (this.countSubscription) {
      this.countSubscription.unsubscribe();
      // this.countSubscription = null;
      console.log('count annullata');
    }
    if (this.refreshTimeSubscription) {
      this.refreshTimeSubscription.unsubscribe();
      // this.refreshTimeSubscription = null;
      console.log('timer annullata');
    }
  }

  private async codePolling() {
    if (this.rilevazione.conclusa()) { this.qrcodeval$.next(this.rilevazione.iul); return; }
    this.qrcodeval$.next((await firstValueFrom(this.rilevazionePresenzeService.rilevazioneCode(this.rilevazione)))?.secret);
    const pollingTime = this.configService.getConfigurazione(ChiaveConfig.SECONDI_VALIDITA_QRCODE);
    interval((+pollingTime + 1) * 1000)
    .pipe(
      takeUntil(this.unsubscribeAll$),
      switchMap(() => this.rilevazionePresenzeService.rilevazioneCode(this.rilevazione))
    )
    .subscribe(value => {
      if (this.rilevazione.conclusa()) { this.qrcodeval$.next(this.rilevazione.iul); return; }
      this.qrcodeval$.next(value.secret);
      console.log(`Fetched new QRCode value ${this.qrcodeval$.value}`);
    })
    
    //La subscribe si triggera appena si esce dalla ril-viewer così da interrompere le richieste al qrcode
      this.navigationSubscription = this.router.events.subscribe(ev => {
        if (ev instanceof NavigationStart) {
          const nextUrl = ev.url;
          // considera come 'resto nella pagina' gli URL della view rilevazione
          const stayPrefixes = ['/rilevazione-home', '/raccolta-presenze'];
          const leaving = !stayPrefixes.some(p => nextUrl.startsWith(p));
          if (leaving) {
            console.log('stopSubscriptions()', nextUrl);
            this.stopSubscriptions();
            this.unsubscribeAll$;
          }
        }
      });
  
  }
 }
